var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('v-btn',{attrs:{"color":"primary","loading":_vm.performingRequest,"block":""},on:{"click":_vm.initSignIn}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.buttonIcon))]),_vm._v(" "+_vm._s(_vm.buttonText)+" ")],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }